import React from 'react';
import { Modal, Form, Input, message } from 'antd';
import styles from "./changepassword.module.less";
import { axiosPost } from '../../server/index'
import common from '../../public/common'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { getCookieNew, md5hex } from '../../public/utils'
import { get } from 'lodash'
class ChangePassWord extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modaltitle: '修改密码',
      warntext: '当前账号密码为初始密码，安全等级较低，请修改密码后再登录操作！',
      warnchangetext: '当前账号密码安全等级较低，请修改密码后再登录操作！',
    }
  }
  formaction = React.createRef()

  handleOk = () => {
    this.formaction.current.validateFields().then(async (values) => {
      if (values.password !== values.password2) {
        message.error('两次密码输入必须一致！')
        return false
      }
      const res = await axiosPost(
        common.eurekaUrlDic + "/auth/upd-pwd",
        {
          account: getCookieNew('phone') || '',
          old_pwd: md5hex(values.old),
          new_pwd: md5hex(values.password)
        })
      if (get(res, "data.code") === 200) {
        message.success('密码修改成功！')
       setTimeout(() => {
        window.location.href = "/login"
       }, 1000);
      }else if (get(res,"data.message")){
        message.warn(get(res,"data.message"))
      }

    });
  }
  handleCancel = () => {
    if (!this.props.isClick) {
      window.location.href = "/login"
      return false
    }
    this.props.passwordChange(false)
  }
  render() {
    let { modaltitle, warntext, warnchangetext } = this.state
    const formItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 8 },
    }
    return (
      <Modal
        title={modaltitle}
        open={this.props.changePasswordStatus}
        destroyOnClose={true}
        onOk={this.handleOk}
        keyboard={false}
        maskClosable={false}
        onCancel={this.handleCancel}

        closable={this.props.isClick ? true : false}
        cancelText={this.props.isClick ? '取消' : '退出系统'}
      >
        {this.props.showMes ? <p><ExclamationCircleOutlined style={{ color: '#f5222d', marginRight: '16px' }} /> {this.props.isClick ? warnchangetext : warntext}</p> : null}
        <Form {...formItemLayout} ref={this.formaction}>
          <Form.Item label="当前密码" rules={[{ required: true, message: '当前密码' }]} name="old">
            <Input type="password" className={styles.inputText} placeholder="当前密码" />
          </Form.Item>
          <Form.Item label="新密码" rules={[{ required: true, message: '新密码输入不符合规则', pattern: '^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$' }]} name="password">
            <Input type="password" className={styles.inputText} placeholder="密码由6-16位字母数字组合，区分大小写" />
          </Form.Item>
          <Form.Item label="确认密码" rules={[{ required: true, message: '重新输入新密码', pattern: '^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$' }]} name="password2">
            <Input type="password" className={styles.inputText} placeholder="重新输入新密码" />
          </Form.Item>

        </Form>
      </Modal>
    )
  }
}
export default ChangePassWord



// WEBPACK FOOTER //
// ./src/compenents/changepassword/changepassword.js